import { isFeatureEnabled } from 'owa-feature-flags';

export function postToWac(
    iframeElement: HTMLIFrameElement,
    wacUrl: string,
    accessToken: string,
    accessTokenTtl: number,
    additionalParameters: string,
    accessTokenAndAdditionalParameters: string,
    isCloudy?: boolean
) {
    const accessTokenRegex = /([?&])access_token=([^&]+)/;
    const replaceValue = '$1';

    if (isFeatureEnabled('doc-SxS-useNewAccessToken')) {
        // Remove the access token from the URL, and use value that was provided separately.
        // This code should be removed as part of the fix to 78599.
        if (accessTokenRegex.test(wacUrl)) {
            wacUrl = wacUrl.replace(accessTokenRegex, replaceValue);
        }
    } else {
        // Extract the access token from the URL.
        accessToken = null;
        if (accessTokenRegex.test(wacUrl)) {
            accessToken = decodeURIComponent(wacUrl.match(accessTokenRegex)[2]);
            wacUrl = wacUrl.replace(accessTokenRegex, replaceValue);
        }
    }

    wacUrl += '&hh=1'; // hide header
    wacUrl += '&mscc=1'; // hide cookie banner
    wacUrl += '&sdr=1'; // GDPR compliance
    wacUrl += '&uiembed=1';
    wacUrl += '&wdorigin=OWA-SXS';
    wacUrl += '&accloop=1';

    if (isCloudy) {
        wacUrl += '&uih=owalegacy';

        if (isFeatureEnabled('doc-SxS-jsApi-ODB-Basecf')) {
            wacUrl += '&wdOwaUnifiedFlight=0';
        }
    }

    iframeElement.onload = () => {
        iframeElement.onload = null;

        const iframeDocument = iframeElement.contentDocument;

        if (!iframeDocument.body) {
            iframeDocument.write('<body><div></div></body>');
        }

        const formElement = iframeDocument.createElement('form');
        formElement.action = wacUrl;
        formElement.method = 'POST';
        formElement.style.visibility = 'hidden';

        if (accessToken) {
            const inputElement = iframeDocument.createElement('input');
            inputElement.type = 'hidden';
            inputElement.name = 'access_token';
            inputElement.value = accessToken;
            formElement.appendChild(inputElement);
        }

        if (accessTokenTtl > 0) {
            // The server sends "time to live" as measured in seconds.
            // WOPI requires an absolute time (and they apologize).
            // This code will hack around that until the server is updated.
            if (accessTokenTtl < Date.UTC(2020, 1, 1, 0, 0, 0)) {
                // Despite declaring accessTokenTtl as a number, Javascipt
                // still wants to do string concatenation on this line,
                // unless the Number() function is used.
                accessTokenTtl = Number(accessTokenTtl) + new Date().getTime();
            }

            const inputElement = iframeDocument.createElement('input');
            inputElement.type = 'hidden';
            inputElement.name = 'access_token_ttl';
            inputElement.value = accessTokenTtl.toString();
            formElement.appendChild(inputElement);
        }

        if (isFeatureEnabled('doc-SxS-useNewAccessToken')) {
            if (additionalParameters) {
                const parts = additionalParameters.split('&');
                for (let i = 0; i < parts.length; i++) {
                    const pair = parts[i].split('=');
                    if (pair.length === 2) {
                        const inputElement = iframeDocument.createElement('input');
                        inputElement.type = 'hidden';
                        inputElement.name = pair[0];
                        inputElement.value = decodeURIComponent(pair[1]);
                        formElement.appendChild(inputElement);
                    }
                }
            }
        } else {
            if (accessTokenAndAdditionalParameters) {
                const tokenParts = accessTokenAndAdditionalParameters.split('&');
                for (let i = 0; i < tokenParts.length; i++) {
                    const tokenPair = tokenParts[i].split('=');
                    if (tokenPair.length === 2) {
                        const inputElement = iframeDocument.createElement('input');
                        inputElement.type = 'hidden';
                        inputElement.name = tokenPair[0];
                        inputElement.value = decodeURIComponent(tokenPair[1]);
                        formElement.appendChild(inputElement);
                    }
                }
            }
        }

        iframeDocument.body.appendChild(formElement);
        formElement.submit();
    };

    iframeElement.src = 'about:blank';
}
